export default "__VITE_ASSET__Cq6b$moV__"